import { Component, ViewChild } from '@angular/core';
import { ModalDirective, BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AppBase } from '../../app-base';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-modal-session',
  templateUrl: './modal-session.component.html',
  styleUrls: ['./modal-session.component.sass']
})
export class ModalSessionComponent extends AppBase {
  @ViewChild('childModal') public childModal: ModalDirective;
  public modalRef: BsModalRef;

  constructor(private authenticationService: AuthenticationService,
              private translationService: TranslationService,
              private router: Router) {
    super();
  }

  public openModal(currentUser) {
    if (!this.currentUser) {
      this.goOut();
    }
    // this.currentUser = currentUser;
    this.childModal.show();
  }

  public logout() {
    this.cleanStorage();
    this.childModal.hide();
  }

  public goOut() {
    this.router.navigate(['/auth']);
    window.location.reload();
  }

  public reauthenticate() {
    if (this.currentUser) {
      this.authenticationService.reauthenticate(this.currentUser.exchange_token)
        .subscribe(
          data => {
            this.setCurrentUser(data);
            /*
            this.translationService.getLocaleSettingsById(data.locale_id)
              .subscribe(locale => {
                this.setLocaleSettings({
                  symbol: locale.currencies[locale.currency_id].symbol,
                  decimal_separator: locale.decimal_separator,
                  thousands_separator: locale.thousands_separator,
                });
              });
              */
            this.childModal.hide();
            this.router.navigate(['/communities']);
            window.location.reload();
          },
          (err) => {
            console.log(err);
            this.router.navigate(['/auth']);
            window.location.reload();
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/modal-session/modal-session.component.ts